export default {
  searchType: 'simple',
  globalSearch: '',
  showTable: false,
  account: {},
  accounts: [],
  item: {},
  items: [],
  totalItems: 0,
  loading: true,
  registerLoading: false,
  options: {
    itemsPerPage: 10,
    page: 1,
    sortBy: ['id'],
    sortDesc: [true],
  },
  deleteDialog: false,
  bulkDeleteDialog: false,
  bulkHideDialog: false,
  registerDialog: false,
  registerAccount: {},
  deleteItem: {},
  bulkDeleteItems: [],
  bulkHideItems: [],
  collection: '',
  collections: [],
  suportes: [],
  idiomas: [],
  filter: {
    conditionals: {
      first: {
        select: 'sinopse',
        conditional: 'AND',
      },
      second: {
        select: 'nome',
        conditional: 'AND',
      },
      third: {
        select: 'conteudo',
        conditional: 'AND',
      },
      fourth: {
        select: 'palavrachave',
        conditional: 'AND',
      },
      fifth: {
        select: 'autor',
        conditional: 'AND',
      },
    },
    idioma: {
      idiomaConditional: 'AND',
    },
    suporte: {
      suporteConditional: 'AND',
    },
  },
};
